<template>
	<div class="soludetail">
		<div class="content">
			<div class="title">
				<div class="mytit1">{{project.title}}</div>
				<div class="mytit2">{{project.tag}}</div>
				<div class="mytit3">{{project.city}}</div>
			</div>
			<div class="myswiper" v-if="dataList.length>0">
				<img src="../../../static/images/scroll-l.png"   class="myscroll-l"  alt="">
				<img src="../../../static/images/scroll-r.png"  class="myscroll-r"  alt="">
				<swiper :options="swiperOption">
					<swiper-slide class="swiper-slide" v-for="(item,index) in dataList" :key="index">
						<img class="swiper-img" :src="item.pic"  style="height:auto"/>
					</swiper-slide>
					<!-- 分页器 -->
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
			<div class="main">
				<div class="maintit" v-html="project.content"></div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: "soludetail",
		data() {
			return {
				soluid: '',
				swiperOption: {
					notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
					// direction: "vertical", //水平方向移动
					grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
					setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
					// autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
					slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
					// mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
					mousewheelControl: true, //同上
					// height: window.innerHeight, // 高度设置，占满设备高度
					resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
					observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
					pagination: {
						el: ".swiper-pagination",
						clickable: true
					},
					navigation: {
					  prevEl: '.myscroll-l',
					  nextEl: '.myscroll-r',
					},
					loop: true,
					autoplay: true,
					autoplay: {
					  disableOnInteraction: false,
					  delay:2000,
					},
					speed:1000,
				},
				observer:true,
				project:'',
				dataList:[
				
				],
			}
		},
		created(){
			this.soluid = this.$route.query.soluid;
			this.getData()
			// this.spage = this.$route.query.spage;
			// var that=this
			// window.addEventListener("popstate", function(e) {
			// 	sessionStorage.setItem("spage", that.spage)
			// }, false);
		},
		methods: {
			getData() {
			  var that = this;
			  let data = {id:that.soluid};
			  that.$api.projectDetail(data).then(res => {
			    if (res.status == 1) {
					that.project = res.data.project;
					that.dataList = res.data.project_pic;
			    } else {
			      that.$message({
			        message: res.msg,
			        type: "warning"
			      });
			    }
			  });
			}
		},
		
	}
</script>

<style>
	.soludetail {
		width: 100%;
		background: #fff;
	}

	.soludetail .content {
		width: 120rem;
		margin: 0 auto;
		padding: 3.0rem 0 5.0rem;
	}
	.soludetail .myswiper{
		position: relative;
	}
	.soludetail .myswiper .myscroll-l,.myscroll-r{
	  position: absolute;
	  width:5rem;
	  height: 5rem;
	  top: 46%;
	  outline: none;
	}
	.soludetail .myswiper .myscroll-l{
	  left: -5rem;
	  z-index: 1999;
	}
	.soludetail .myswiper .myscroll-r{
	  right: -5rem;
	  z-index: 1999;
	}
	.soludetail .title {
		width: 100%;
		padding: 2.6rem 0 5.0rem;
		text-align: center;
		font-size: 1.6rem;
		color: #4c4c4c;
	}

	.soludetail .title .mytit1 {
		margin-bottom: 0.6rem;
		font-size: 3.2rem;
	}

	.soludetail .title .mytit2 {
		margin-bottom: 1.5rem;
		font-size: 1.6rem;
	}

	.soludetail .title .mytit3 {
		font-size: 1.4rem;
	}
	.soludetail .swiper-container{
		width: 100%;
	}
	.soludetail .swiper-wrapper{
		height: auto;
	}
	.soludetail .swiper-img {
		width: 100%;
	}
	.soludetail .swiper-container> .swiper-pagination-bullets {
	    bottom: 3.0rem;
	}
	.soludetail .swiper-pagination .swiper-pagination-bullet {
	  width: 10px;
	  height: 10px;
	  background-color: #fff;
	  opacity: 1;
	}
	.soludetail .swiper-pagination .swiper-pagination-bullet-active {
	  background-color: #000;
	}
	.soludetail .main{
		width: 100%;
		padding: 3.0rem 0;
	}
	.soludetail .main .maintit{
		text-align: left;
		font-size: 1.4rem;
		color: #808080;
		line-height: 3.0rem;
	}
	.soludetail .main .maintit p{
		margin-bottom: 2.0rem;
/* 		word-break: break-all;
		word-wrap: break-word;  
		white-space: pre-wrap; */
		text-align:justify; 
		text-justify:inter-ideograph;
	}
	
	@media(max-width:1200px) {
		.soludetail .content{
			width: 92%;
		}
		.soludetail .myswiper .myscroll-l,.myscroll-r{ 
		  width:4rem;
		  height: 4rem;
		}
		.soludetail .myswiper .myscroll-l{
		  left: -3.9rem;
		}
		.soludetail .myswiper .myscroll-r{
		  right: -3.9rem;
		}
	}
	@media(max-width:768px) {
		.soludetail .content{
			width: 85%;
		}
		.soludetail .swiper-container> .swiper-pagination-bullets {
		    bottom: 1.0rem;
		}
		.soludetail .myswiper .myscroll-l,.myscroll-r{
		  width:2.6rem;
		  height:2.6rem;
		}
		.soludetail .myswiper .myscroll-l{
		  left: -2.3rem;
		}
		.soludetail .myswiper .myscroll-r{
		  right: -2.3rem;
		}
	}
</style>
